import { selectProfile, selectUpdatingProfileInfo } from '../../../../../store/workspace/selectors';
import { setEditAccountInfoModal } from '../../../../../store/workspace/slice';
import { updateProfileInfoThunk } from '../../../../../store/workspace/thunks';
import { useDispatch, useSelector } from '../../../../../store/store';
import { EditSquareIcon } from '../../../../../assets/icons';
import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal';
import Input from '../../../../../components/Input';
import styles from './style.module.scss';
import { useState } from 'react';

export default function EditAccountInfo() {
    const dispatch = useDispatch();
    const profile = useSelector(selectProfile);
    const isLoading = useSelector(selectUpdatingProfileInfo);
    const [lastName, setLastName] = useState(profile?.lastName || '');
    const [firstName, setFirstName] = useState(profile?.firstName || '');

    const submit = () => {
        dispatch(updateProfileInfoThunk({
            ...profile,
            lastName,
            firstName,
        }))
    };

    return (
        <Modal
            size='sm'
            icon={<EditSquareIcon />}
            childClassName={styles.wrapper}
            title='Edit account information'
            closeFunc={() => dispatch(setEditAccountInfoModal(false))}
        >
            <Input
                type='text'
                label='First name'
                value={firstName}
                onChange={setFirstName}
            />
            <Input
                type='text'
                label='Last name'
                value={lastName}
                onChange={setLastName}
            />
            <div className={styles.actions}>
                <Button
                    type='Outline-Primary'
                    text='Cancel'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setEditAccountInfoModal(false))}
                />
                <Button
                    type='Primary'
                    text='Confirm'
                    onClick={submit}
                    disabled={!profile}
                    loading={isLoading}
                    className={styles.actions_btn}
                />
            </div>
        </Modal>
    )
}
